import TucsonHeroSection from "./components/HeroSection";
import TucsonStickyNav from "./components/StickyNav";
import TucsonProcessingTimeSection from "./components/ProcessingTimeSection";
import TucsonServicesSection from "./components/ServicesSection";
import TucsonLocalAreaSection from "./components/LocalAreaSection";
import TucsonTravelTimingSection from "./components/TravelTimingSection";
import TucsonDestinationsSection from "./components/DestinationsSection";
import TucsonTestimonialsSection from "./components/TestimonialsSection";
import TucsonAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import TucsonComparisonSection from "./components/ComparisonSection";
import TucsonMistakesSection from "./components/MistakesSection";
import TucsonHowItWorksSection from "./components/HowItWorksSection";
import TucsonFAQSection, { faqs } from "./components/FAQSection";
import TucsonHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import TucsonFinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function TucsonPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Tucson"
        state="Arizona"
        stateAbbr="AZ"
        route="/cities/tucson"
        title="Emergency Passport Tucson, AZ — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Tucson, AZ — as fast as 24 hours. Serving University of Arizona students, Davis-Monthan AFB families, Raytheon engineers, and Southern Arizona residents. A+ BBB rated, registered State Dept. courier. No Phoenix agency drive required."
        geoPlacename="Tucson, Arizona"
        geoPosition="32.2226;-110.9747"
        faqs={faqs}
        servicesSchema={[
          { name: "Emergency Passport", description: "UA student with a study abroad flight in 48 hours? Davis-Monthan airman with deployment orders? As fast as 24 hours with reserved agency submission." },
          { name: "Passport Renewal", description: "Fast renewal for Tucson professionals, Raytheon engineers, and UA faculty — ship overnight from any Tucson FedEx or UPS." },
          { name: "New Passport", description: "First-time applicants — UA freshmen, new Arizona residents, D-M families — guided through every step with a clear checklist." },
          { name: "Lost or Stolen Passport", description: "DS-64 and DS-11 guidance so Tucson travelers can replace lost passports on the fastest possible timeline." },
          { name: "Child Passport", description: "Minors require parental participation and in-person acceptance. Clear instructions for Tucson and Southern Arizona families." },
          { name: "Name Change", description: "Post-marriage, divorce, or legal name change — corrected passports for Tucson and Pima County residents." },
          { name: "Second Passport", description: "Need a second passport for frequent international travel? Ideal for Raytheon defense contractors, UA researchers, and business travelers whose primary passport is in visa processing." },
          { name: "Damaged Passport", description: "Replacing a significantly damaged passport is faster than you think. We guide you through the process so your international itinerary stays on track." },
          { name: "Passport Card", description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Same expedited processing as book passports." },
        ]}
        statePageName="Arizona"
        statePageRoute="/states/arizona"
        areaServedList={[
          { "@type": "City", name: "Tucson" },
          { "@type": "City", name: "Oro Valley" },
          { "@type": "City", name: "Marana" },
          { "@type": "City", name: "Sahuarita" },
          { "@type": "City", name: "Green Valley" },
          { "@type": "City", name: "Vail" },
          { "@type": "AdministrativeArea", name: "Pima County" },
        ]}
        serviceAreaDesc="Fast Passport Center is a registered U.S. Department of State passport courier serving Tucson, Oro Valley, Marana, Sahuarita, Green Valley, and all of Pima County with expedited passport processing as fast as 24 hours. A+ BBB rated. Remote service — all business conducted by mail/overnight courier from our Phoenix office at 4742 N 24th St."
      />
      <TucsonHeroSection />
      <TucsonStickyNav />
      <TucsonProcessingTimeSection />
      <TucsonLocalAreaSection />
      <TucsonServicesSection />
      <TucsonTravelTimingSection />
      <TucsonDestinationsSection />
      <TucsonTestimonialsSection />
      <TucsonAcceptanceFacilitiesSection />
      <TucsonComparisonSection />
      <TucsonMistakesSection />
      <TucsonHowItWorksSection />
      <TucsonFAQSection />
      <TucsonHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/tucson" state="AZ" />
      <TucsonFinalCTA />
    </div>
  );
}